import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Icon } from '../Icon';
import httpsImageSrc from '../../assets/images/subscription/https-chip.png';
import applePayImageSrc from '../../assets/images/subscription/apple-pay-chip.png';
import googlePayImageSrc from '../../assets/images/subscription/google-pay-chip.png';
import visaImageSrc from '../../assets/images/subscription/visa-chip.png';
import mastercardImageSrc from '../../assets/images/subscription/mastercard-chip.png';
import maestroImageSrc from '../../assets/images/subscription/maestro-chip.png';
import discoverImageSrc from '../../assets/images/subscription/discover-chip.png';
import amexImageSrc from '../../assets/images/subscription/americanexpress-chip.png';
import unionpayImageSrc from '../../assets/images/subscription/unionpay-chip.png';
import styles from './PaymentInformationBlockV2.css';

const cx = classnames.bind(styles);

function PaymentInformationBlockV2({
    className = '',
    label = 'PAY safe & secure'
}) {
    const classes = cx({
        root: true,
        [className]: Boolean(className)
    });

    return (
        <div className={classes}>
            <div className={styles.safeBlock}>
                <Icon name='lockSolid' />
                <span>{label}</span>
            </div>
            <div className={styles.rows}>
                <ul className={styles.list}>
                    <li><img alt='https' src={httpsImageSrc} /></li>
                    <li><img alt='Apple Pay' src={applePayImageSrc} /></li>
                    <li><img alt='Google Pay' src={googlePayImageSrc} /></li>
                    <li><img alt='visa' src={visaImageSrc} /></li>
                    <li><img alt='mastercard' src={mastercardImageSrc} /></li>
                    <li><img alt='maestro' src={maestroImageSrc} /></li>
                </ul>
                <ul className={styles.list}>
                    <li><img alt='discover' src={discoverImageSrc} /></li>
                    <li><img alt='american express' src={amexImageSrc} /></li>
                    <li><img alt='unionpay' src={unionpayImageSrc} /></li>
                </ul>
            </div>
        </div>
    );
}

PaymentInformationBlockV2.propTypes = {
    className: PropTypes.string,
    label: PropTypes.string
};

export {
    PaymentInformationBlockV2
};
